// 🎨 Estilo
export const ui = {
    container: {
        padding: 24,
        backgroundColor: '#f8fafc',
        minHeight: '95vh',
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        boxSizing: 'border-box',
        marginBottom: 40
        // paddingBottom: 40 // espaço extra no fim
    },
    header: { display: 'flex', justifyContent: 'space-between', marginBottom: 24, alignItems: 'center' },
    title: { fontSize: '1.5rem', fontWeight: '600', color: '#1f2937' },
    homeButton: { background: '#6b7280', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: 8, cursor: 'pointer' },

    filters: {
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 16,
        background: '#fff',
        padding: 16,
        borderRadius: 12,
        border: '1px solid #e5e7eb',
        marginBottom: 24,
        overflowX: 'auto', // Adicionei isso para barras de rolagem horizontais, se necessário
    },
    filterGroup: { display: 'flex', flexDirection: 'column' },
    label: { fontSize: 14, fontWeight: '500', marginBottom: 4 },
    input: {
        padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: 8
    },
    select: { padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: 8 },
    actionsRow: { display: 'flex', gap: 8, alignItems: 'center' },

    buttonPrimary: { background: '#667eea', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer' },
    buttonLight: { background: '#e5e7eb', color: '#111827', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer' },
    buttonFatur: { background: '#978729ff', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer' },
    buttonGreen: { background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer' },

    tableCard: { background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' },
    tableCardCli: {
        background: '#fff',
        borderRadius: 12,
        border: '1px solid #e5e7eb',
        // --- MUDANÇAS AQUI ---
        display: 'flex',
        justifyContent: 'center', // Centraliza o conteúdo horizontalmente
        flexDirection: 'column',  // Garante que o conteúdo vá de cima para baixo
        // --- FIM MUDANÇAS ---
    },
    tableScroll: { maxHeight: '60vh', overflow: 'auto', borderRadius: 12, width: '100%' },
    tableScrollCli: {
        maxHeight: '60vh',
        overflow: 'auto',
        borderRadius: 12,
        // width: '100%', <--- REMOVA
        maxWidth: '100%', // Adiciona um limite para não estourar a tela
        margin: '0 auto',  // <--- ADICIONA MARGEM AUTO PARA CENTRALIZAÇÃO
    },
    table: { width: '100%', tableLayout: 'fixed', borderCollapse: 'separate', borderSpacing: 0 },
    tableCli: {
        minWidth: '100%', // <--- NOVO: Garante que ela ocupe pelo menos 100% do seu pai (tableScroll)
        tableLayout: 'fixed',
        borderCollapse: 'separate',
        borderSpacing: 0
    },
    thead: { position: 'sticky', top: 0, background: '#f3f4f6', zIndex: 1 },
    th: {
        textAlign: 'left', padding: '10px 12px',
        borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#374151', background: '#f3f4f6'
    },
    thRigth: {
        textAlign: 'center', padding: '10px 12px',
        borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#374151', background: '#f3f4f6'
    },
    thSmall: {
        width: 70, textAlign: 'left', padding: '10px 12px',
        borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#374151', background: '#f3f4f6'
    },
    thActions: {
        width: 160, textAlign: 'center', padding: '12px 14px',
        borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#374151', background: '#f3f4f6'
    },

    tr: { borderBottom: '1px solid #eef2f7', fontSize: 14 },
    td: { padding: '10px 10px', borderBottom: '1px solid #eef2f7', color: '#111827' },
    tdMono: {
        padding: '10px 10px',
        borderBottom: '1px solid #eef2f7',
        color: '#111827',
        fontFamily:
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    tdCenter: {
        padding: '10px 10px',
        borderBottom: '1px solid #eef2f7',
        color: '#111827',
        fontFamily:
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'center'
    },
    tdClamp: {
        padding: '10px 14px', borderBottom: '1px solid #eef2f7', color: '#111827',
        maxWidth: 280, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
    },

    tdActions: { padding: '5px 5px', borderBottom: '1px solid #eef2f7', textAlign: 'center' },
    actions: { display: 'flex', gap: 5 },

    actionView: { background: '#3b82f6', border: 'none', color: '#fff', padding: 6, borderRadius: 6, cursor: 'pointer', marginLeft: 10 },
    actionEdit: { background: '#fbbf24', border: 'none', color: '#fff', padding: 6, borderRadius: 6, cursor: 'pointer', marginLeft: 10 },
    actionDelete: { background: '#ef4444', border: 'none', color: '#fff', padding: 6, borderRadius: 6, cursor: 'pointer', marginLeft: 10 },

    pagination: { display: 'flex', gap: 8, marginTop: 16, justifyContent: 'center' },
    // page: { border: '1px solid #e5e7eb', background: '#fff', padding: '6px 12px', borderRadius: 6, cursor: 'pointer' },
    pageActive: { border: '1px solid #667eea', background: '#667eea', color: '#fff', padding: '6px 12px', borderRadius: 6 },

    page: { border: '1px solid #e5e7eb', background: '#fff', padding: '6px 12px', borderRadius: 6, cursor: 'pointer' },
    pageActive: { border: '1px solid #667eea', background: '#667eea', color: '#fff', padding: '6px 12px', borderRadius: 6 },
    pageEllipsis: { padding: '6px 12px', color: '#6b7280', userSelect: 'none' },

    // ... [Estilos anteriores do seu arquivo]

    // --- ESTILOS DO MODAL (Adicionar estes) ---
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modalReajuste: {
        position: 'fixed',
        inset: 0, // top, right, bottom, left = 0
        backgroundColor: 'rgba(15, 23, 42, 0.75)', // azul escuro elegante
        backdropFilter: 'blur(4px)', // dá separação visual
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1300,
    },
    modalCard: {
        backgroundColor: 'rgba(249, 248, 250, 1)',
        borderRadius: '14px',
        padding: '24px',
        width: '100%',
        maxWidth: '480px',
        boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
        position: 'relative',
        animation: 'fadeInScale 0.2s ease-out',
    },
    modalContent: {
        backgroundColor: '#fff',
        borderRadius: 12,
        width: '90%',
        maxWidth: 700,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
        position: 'relative', // Necessário para o header sticky
    },
    modalHeader: {
        padding: '16px 24px',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        // position: 'sticky', // Opcional, se quiser cabeçalho fixo ao rolar
        top: 0,
        backgroundColor: '#fff',
        zIndex: 10,
    },
    modalTitle: {
        fontSize: '1.25rem',
        fontWeight: '600',
        color: '#1f2937',
    },
    modalCloseButton: {
        background: 'transparent',
        border: 'none',
        fontSize: '1.2rem',
        color: '#6b7280',
        cursor: 'pointer',
        padding: 8,
        borderRadius: '50%',
        transition: 'background 0.2s',
    },
    modalBody: {
        padding: '24px',
    },
    modalFooter: {
        padding: '16px 24px',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 12,
        // position: 'sticky', // Opcional, se quiser rodapé fixo ao rolar
        bottom: 0,
        backgroundColor: '#fff',
        zIndex: 10,
    },
    formGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        marginBottom: 24,
    },
    formGroup: {
        display: 'flex',
        flexDirection: 'column'
    },


};
